// extracted by mini-css-extract-plugin
export default {"productDescription":"uda-z","featuredDescription":"vda-z","description":"wda-z","more":"xda-z","descriptionSku":"yda-z"};